import { config, appFetch } from "../appFetch";

export const registerUser = (formData, onSuccess, onError) => appFetch(`https://api.galicine.com.es/api/user/function::altare`, config('POST', formData), onSuccess, onError);

export const logIn = (formData, onSuccess, onError) => appFetch(`https://api.galicine.com.es/api/user/function::loginre`, config('POST', formData), onSuccess, onError);
export const recoverPassword = (formData, onSuccess, onError) => appFetch(`https://api.galicine.com.es/api/user/function::recuperarpinre`, config('POST', formData), onSuccess, onError);

export const logOut = (uuid, cine, onSuccess, onError) => appFetch(`https://api.galicine.com.es/api/user/function::logoutre`, config('POST', { cine, uuid }), onSuccess, onError);
